module.exports = __webpack_public_path__ + "img/dark-mud-decal-15.d6632a76.png";